module.exports = __webpack_public_path__ + "static/x58-7fb0373ec6359e932b602f36729cbd75.png";